module.exports = __webpack_public_path__ + "static/media/zebra05.07f37a1a.png";